module.exports = __webpack_public_path__ + "static/media/employersectionImage.fd6314d2.png";